"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.luyanstore = void 0;
var mobx_1 = require("mobx");
(0, mobx_1.configure)({ useProxies: "ifavailable" });
var LuYanStore = /** @class */ (function () {
    function LuYanStore() {
        this._env = "production"; // 开发环境
        this.istest = false; // 是否是测试直播间
        /**
         * 直播区遮罩
         */
        this.showblurSmegma = false; // zb_content 遮罩蒙层
        /**
         * 展示发言框
         */
        this.showChatPost = true;
        /**
         * 展示互动列表
         */
        this.showChatList = true;
        /**
         * 禁止互动
         */
        this.forbidChat = false;
        /**
         * 白名单按钮校验相关
         * @params needauth 需要预约报名等校验
         * @params onBtnFun 预约or报名点击事件
         * @params btntxt btn文案
         */
        this.authBtnEvents = {
            needauth: false,
            onBtnFun: null,
            btntxt: "",
            btnclass: "",
            rightBtnClass: "",
            tips: ""
        };
        /**
         * 相关公司
         */
        this.relationstock = {
            MarketCode: null,
            StockCode: null
        };
        (0, mobx_1.makeAutoObservable)(this);
    }
    // 是否是测试直播间
    LuYanStore.prototype.setIstest = function (val) {
        this.istest = val;
    };
    // 运行环境
    LuYanStore.prototype.setEnv = function (val) {
        this._env = val;
    };
    return LuYanStore;
}());
exports.luyanstore = new LuYanStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdG9yZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBaUU7QUFHakUsSUFBQSxnQkFBUyxFQUFDLEVBQUUsVUFBVSxFQUFFLGFBQWEsRUFBRSxDQUFDLENBQUE7QUFHeEM7SUFtREU7UUFqREEsU0FBSSxHQUFHLFlBQVksQ0FBQSxDQUFFLE9BQU87UUFHNUIsV0FBTSxHQUFHLEtBQUssQ0FBQyxDQUFDLFdBQVc7UUFFM0I7O1dBRUc7UUFDSCxtQkFBYyxHQUFHLEtBQUssQ0FBQSxDQUFHLGtCQUFrQjtRQUUzQzs7V0FFRztRQUNILGlCQUFZLEdBQUcsSUFBSSxDQUFBO1FBRW5COztXQUVHO1FBQ0gsaUJBQVksR0FBRyxJQUFJLENBQUE7UUFFbkI7O1dBRUc7UUFDSCxlQUFVLEdBQUcsS0FBSyxDQUFBO1FBRWxCOzs7OztXQUtHO1FBQ0gsa0JBQWEsR0FBRztZQUNkLFFBQVEsRUFBQyxLQUFLO1lBQ2QsUUFBUSxFQUFFLElBQVc7WUFDckIsTUFBTSxFQUFDLEVBQUU7WUFDVCxRQUFRLEVBQUMsRUFBRTtZQUNYLGFBQWEsRUFBQyxFQUFFO1lBQ2hCLElBQUksRUFBQyxFQUFFO1NBQ1IsQ0FBQTtRQUVEOztXQUVHO1FBQ0gsa0JBQWEsR0FBRztZQUNkLFVBQVUsRUFBRSxJQUFJO1lBQ2hCLFNBQVMsRUFBRSxJQUFJO1NBQ2hCLENBQUE7UUFJQyxJQUFBLHlCQUFrQixFQUFDLElBQUksQ0FBQyxDQUFBO0lBQzFCLENBQUM7SUFHRCxXQUFXO0lBQ1gsOEJBQVMsR0FBVCxVQUFVLEdBQVk7UUFDcEIsSUFBSSxDQUFDLE1BQU0sR0FBRyxHQUFHLENBQUE7SUFDbkIsQ0FBQztJQUdELE9BQU87SUFDUCwyQkFBTSxHQUFOLFVBQU8sR0FBVztRQUNoQixJQUFJLENBQUMsSUFBSSxHQUFHLEdBQUcsQ0FBQTtJQUNqQixDQUFDO0lBR0gsaUJBQUM7QUFBRCxDQUFDLEFBcEVELElBb0VDO0FBRVUsUUFBQSxVQUFVLEdBQUcsSUFBSSxVQUFVLENBQUEifQ==